"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var QuestionBox = function QuestionBox(_ref) {
  var children = _ref.children,
      option1 = _ref.option1,
      option2 = _ref.option2,
      className = _ref.className,
      disabled = _ref.disabled,
      response = _ref.response,
      otherProps = _objectWithoutProperties(_ref, ["children", "option1", "option2", "className", "disabled", "response"]);

  var handleClick = function handleClick(e) {
    response(e.currentTarget.innerHTML);
  };

  return /*#__PURE__*/_react.default.createElement(Container, _extends({}, otherProps, {
    className: className
  }), /*#__PURE__*/_react.default.createElement(Question, null, /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: children
    }
  })), option1 || option2 ? /*#__PURE__*/_react.default.createElement(Answers, null, /*#__PURE__*/_react.default.createElement(Answer, {
    className: "option1",
    disabled: disabled,
    left: true,
    onClick: function onClick(e) {
      return disabled ? e.preventDefault() : handleClick(e);
    }
  }, option1), /*#__PURE__*/_react.default.createElement(Answer, {
    className: "option2",
    left: false,
    onClick: function onClick(e) {
      handleClick(e);
    }
  }, option2)) : null);
};

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["display:flex;font-family:", ";flex-direction:column;align-items:center;width:100%;box-shadow:0 0.2rem 0.7rem rgba(0,0,0,0.1);border-radius:0;border-radius:0 1.6rem 1.6rem;z-index:10;position:relative;align-self:flex-end;margin:auto;margin-top:0;margin-bottom:3rem;flex-shrink:0;background-color:white;padding-bottom:4.5rem;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var Answers = _styledComponents.default.div.withConfig({
  displayName: "Answers"
})(["width:100%;display:flex;position:absolute;bottom:0;"]);

var Answer = _styledComponents.default.p.withConfig({
  displayName: "Answer"
})(["width:50%;height:5rem;display:flex;position:relative;flex-wrap:nowrap;justify-content:center;align-items:center;font-size:2.1rem;font-weight:500;background-color:", ";color:white;border:solid 0.2rem;border-radius:", ";border-color:", ";cursor:pointer;transition:0.3s;text-decoration:none;&:hover{background-color:", ";cursor:", ";}"], function (_ref3) {
  var theme = _ref3.theme,
      disabled = _ref3.disabled;
  return disabled ? theme.ui.disabled : theme.brand.primary;
}, function (props) {
  return props.left ? '0 0 0 1.6rem' : '0 0 1.6rem 0';
}, function (_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  return disabled ? theme.ui.disabled : theme.brand.secondary;
}, function (_ref5) {
  var theme = _ref5.theme,
      disabled = _ref5.disabled;
  return disabled ? theme.ui.disabled : theme.hover.primary;
}, function (props) {
  return props.disabled ? "default" : "pointer";
});

var Question = _styledComponents.default.div.withConfig({
  displayName: "Question"
})(["display:flex;font-size:1.6rem;width:100%;flex-direction:row;justify-content:space-between;padding:3rem;align-self:flex-start;& span{font-weight:500;}"]);

QuestionBox.defaultProps = {
  disabled: false,
  option1: null,
  option2: null,
  response: Function.prototype,
  otherProps: {}
};
QuestionBox.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Question */
  children: _propTypes.node.isRequired,

  /** option to the left */
  option1: _propTypes.string,

  /** option to the right */
  option2: _propTypes.string,

  /** returns string of clicked option */
  response: _propTypes.func,

  /** if true option1 is disabled */
  disabled: _propTypes.bool,

  /** Adds extra props to the element */
  otherProps: _propTypes.object
};
var _default = QuestionBox;
exports.default = _default;